import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// Note: This page appears to be deprecated in favor of SalesforceCallback.tsx
// It's being kept for backward compatibility but redirects to the new handler

export default function OAuthCallback() {
  const navigate = useNavigate()
  
  useEffect(() => {
    // Redirect to the new Salesforce callback handler
    const currentUrl = window.location.href
    const newUrl = currentUrl.replace('/oauth-callback', '/salesforce-callback')
    window.location.href = newUrl
  }, [navigate])
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-sm text-gray-600">
          Redirecting to Salesforce connection handler...
        </p>
      </div>
    </div>
  )
}